import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search } from 'lucide-react';

interface TaskFiltersProps {
  filters: {
    search: string;
    project: string;
    assignee: string;
    priority: string;
  };
  onFiltersChange: (filters: any) => void;
}

const TaskFilters = ({ filters, onFiltersChange }: TaskFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4">
      {/* Search */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search tasks..."
          value={filters.search}
          onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
          className="pl-10"
        />
      </div>

      {/* Project Filter */}
      <Select
        value={filters.project}
        onValueChange={(value) => onFiltersChange({ ...filters, project: value })}
      >
        <SelectTrigger className="w-full md:w-[200px]">
          <SelectValue placeholder="All Projects" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Projects</SelectItem>
          <SelectItem value="1">LWM PM System</SelectItem>
          <SelectItem value="2">Barcelona E-commerce</SelectItem>
          <SelectItem value="3">Fixaro Platform</SelectItem>
        </SelectContent>
      </Select>

      {/* Assignee Filter */}
      <Select
        value={filters.assignee}
        onValueChange={(value) => onFiltersChange({ ...filters, assignee: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="All Assignees" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Assignees</SelectItem>
          <SelectItem value="1">Roman Siromskyi</SelectItem>
          <SelectItem value="2">Bohdan Buryi</SelectItem>
          <SelectItem value="3">Vlad Dev</SelectItem>
          <SelectItem value="4">Nastya Tishchenko</SelectItem>
          <SelectItem value="5">John Designer</SelectItem>
        </SelectContent>
      </Select>

      {/* Priority Filter */}
      <Select
        value={filters.priority}
        onValueChange={(value) => onFiltersChange({ ...filters, priority: value })}
      >
        <SelectTrigger className="w-full md:w-[150px]">
          <SelectValue placeholder="All Priorities" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Priorities</SelectItem>
          <SelectItem value="low">Low</SelectItem>
          <SelectItem value="normal">Normal</SelectItem>
          <SelectItem value="high">High</SelectItem>
          <SelectItem value="urgent">Urgent</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default TaskFilters;
